import * as React from 'react';
import { themeColor } from 'src/mui-theme';

// Hollow Icon
export function SvgCoupon(props) {
  const { fill, ...rest } = props;
  return (
    <svg width='1em' height='1em' viewBox='0 0 24 20' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <g fillRule='nonzero' fill='none'>
        <g fill={fill || '#757575'}>
          <path d='M9.27 4.46a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zM14.372 11.272a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zM7.939 14.481l8.765-8.358-1.439-1.372L6.5 13.11z' />
        </g>
        <path
          d='M3.2 1.16A2.2 2.2 0 001 3.36v4.4a2.2 2.2 0 110 4.4v4.4a2.2 2.2 0 002.2 2.2h17.6a2.2 2.2 0 002.2-2.2v-4.4a2.2 2.2 0 010-4.4v-4.4a2.2 2.2 0 00-2.2-2.2H3.2'
          stroke={fill || '#757575'}
          strokeWidth={2}
        />
      </g>
    </svg>
  );
}

// Solid Icon
export const SvgCouponActive = (props): JSX.Element => {
  const { fill, ...rest } = props;
  return (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 22 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 2.25C0 1.007.985 0 2.2 0h17.6C21.01 0 22 1 22 2.25v4.5c-1.21 0-2.2 1.001-2.2 2.25 0 1.242.985 2.25 2.2 2.25v4.5c0 1.243-.985 2.25-2.2 2.25H2.2C.985 18 0 16.993 0 15.75v-4.5c1.215 0 2.2-1.008 2.2-2.25 0-1.238-.979-2.25-2.2-2.25v-4.5zm7.02 3.5a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zm5.102 6.811a1.75 1.75 0 
113.5 0 1.75 1.75 0 01-3.5 0zm-4.683 1.46l8.765-8.359-1.439-1.372L6 12.65l1.439 1.372z'
        fill={fill || themeColor.palesky}
      />
      <mask
        id='Coupon_Active_svg__a'
        maskUnits='userSpaceOnUse'
        x={0}
        y={-1}
        width={22}
        height={20}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0 2.25C0 1.007.985 0 2.2 0h17.6C21.01 0 22 1 22 2.25v4.5c-1.21 0-2.2 1.001-2.2 2.25 0 1.242.985 2.25 2.2 2.25v4.5c0 1.243-.985 2.25-2.2 2.25H2.2C.985 18 0 16.993 0 15.75v-4.5c1.215 0 2.2-1.008 2.2-2.25 0-1.238-.979-2.25-2.2-2.25v-4.5zm7.02 3.5a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zm5.102 6.811a1.75 1.75 0 
113.5 0 1.75 1.75 0 01-3.5 0zm-4.683 1.46l8.765-8.359-1.439-1.372L6 12.65l1.439 1.372z'
          fill={fill || themeColor.palesky}
        />
      </mask>
      <g mask='url(#Coupon_Active_svg__a)'>
        <path fill={fill || themeColor.palesky} d='M-1-3h24v24.001H-1z' />
      </g>
    </svg>
  );
};

// Hollow Icon
export const SvgPromotionSelected = (props): JSX.Element => {
  const { fill, ...rest } = props;
  return (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.785 3.102l.622 3.756 3.582 1.741-1.806 3.406 1.816 3.405-3.612 1.742-.622 3.756-3.97-.594L11.97 23l-2.837-2.724-3.938.622-.633-3.785L1 15.381l1.816-3.405L1.01 8.599l3.582-1.76.622-3.728 3.949.623L12 1l2.826 2.695 3.96-.593zm-1.181 5.102l2.648 1.288-1.334 2.515 1.336 2.507-2.67 1.287-.47 2.838-2.988-.447-2.15 2.042-2.175-2.089-2.962.468-.475-2.847-2.622-1.275 1.342-2.517L3.75 9.481 6.395 8.18l.465-2.784 2.974.469 2.173-2.094 2.147 2.047 2.98-.446.47 2.832zM7.918 8.6c0-.806.685-1.46 1.53-1.46.846 0 1.531.654 1.531 1.46 0 .806-.685 1.46-1.53 1.46-.846 0-1.53-.654-1.53-1.46zm6.632 5.352c-.845 0-1.53.653-1.53 1.46 0 .806.685 1.459 1.53 1.459.846 0 1.531-.654 1.531-1.46 0-.806-.685-1.46-1.53-1.46zm2.552-5.44L8.337 16.87l-1.44-1.372 8.766-8.358 1.439 1.372z'
        fill={fill || themeColor.palesky}
      />
      <mask
        id='PromotionSelected_svg__a'
        maskUnits='userSpaceOnUse'
        x={1}
        y={1}
        width={22}
        height={22}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.785 3.102l.622 3.756 3.582 1.741-1.806 3.406 1.816 3.405-3.612 1.742-.622 3.756-3.97-.594L11.97 23l-2.837-2.724-3.938.622-.633-3.785L1 15.381l1.816-3.405L1.01 8.599l3.582-1.76.622-3.728 3.949.623L12 1l2.826 2.695 3.96-.593zm-1.181 5.102l2.648 1.288-1.334 2.515 1.336 2.507-2.67 1.287-.47 2.838-2.988-.447-2.15 2.042-2.175-2.089-2.962.468-.475-2.847-2.622-1.275 1.342-2.517L3.75 9.481 6.395 8.18l.465-2.784 2.974.469 2.173-2.094 2.147 2.047 2.98-.446.47 2.832zM7.918 8.6c0-.806.685-1.46 1.53-1.46.846 0 1.531.654 1.531 1.46 0 .806-.685 1.46-1.53 1.46-.846 0-1.53-.654-1.53-1.46zm6.632 5.352c-.845 0-1.53.653-1.53 1.46 0 .806.685 1.459 1.53 1.459.846 0 1.531-.654 1.531-1.46 0-.806-.685-1.46-1.53-1.46zm2.552-5.44L8.337 16.87l-1.44-1.372 8.766-8.358 1.439 1.372z'
          fill={fill || themeColor.palesky}
        />
      </mask>
      <g mask='url(#PromotionSelected_svg__a)'>
        <path fill={fill || themeColor.palesky} d='M-1-1h26.181v26.181H-1z' />
      </g>
    </svg>
  );
};

// Solid Icon
export const SvgPromotions = (props): JSX.Element => {
  const { fill, ...rest } = props;
  return (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.408 6.858l-.622-3.756-3.96.593L12 1 9.163 3.734l-3.949-.623-.622 3.727L1.01 8.6l1.806 3.377L1 15.38l3.561 1.732.633 3.785 3.939-.622L11.969 23l2.827-2.686 3.97.594.622-3.756L23 15.41l-1.816-3.405 1.806-3.406-3.582-1.741zM8.337 16.87l8.765-8.358-1.439-1.372-8.765 8.358 1.439 1.372zM7.918 8.6c0-.807.686-1.46 1.53-1.46.846 0 1.532.653 1.532 1.46 0 .805-.686 1.459-1.531 1.459-.845 0-1.53-.654-1.53-1.46zm5.102 6.81c0-.806.686-1.46 1.531-1.46.845 0 1.53.654 1.53 1.46 0 .806-.685 1.46-1.53 1.46s-1.53-.654-1.53-1.46z'
        fill={fill || themeColor.palesky}
      />
      <mask id='Promotions_svg__a' maskUnits='userSpaceOnUse' x={1} y={1} width={22} height={22}>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.408 6.858l-.622-3.756-3.96.593L12 1 9.163 3.734l-3.949-.623-.622 3.727L1.01 8.6l1.806 3.377L1 15.38l3.561 1.732.633 3.785 3.939-.622L11.969 23l2.827-2.686 3.97.594.622-3.756L23 15.41l-1.816-3.405 1.806-3.406-3.582-1.741zM8.337 16.87l8.765-8.358-1.439-1.372-8.765 8.358 1.439 1.372zM7.918 8.6c0-.807.686-1.46 1.53-1.46.846 0 1.532.653 1.532 1.46 0 .805-.686 1.459-1.531 1.459-.845 0-1.53-.654-1.53-1.46zm5.102 6.81c0-.806.686-1.46 1.531-1.46.845 0 1.53.654 1.53 1.46 0 .806-.685 1.46-1.53 1.46s-1.53-.654-1.53-1.46z'
          fill={fill || themeColor.palesky}
        />
      </mask>
      <g mask='url(#Promotions_svg__a)'>
        <path fill={fill || themeColor.palesky} d='M0 0h24v23.999H0z' />
      </g>
    </svg>
  );
};

export const SvgPromotionsStar = (props): JSX.Element => {
  const { fill, ...rest } = props;
  return (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1 5.24977C1 4.00709 1.98497 2.99969 3.2 2.99969H20.8C22.01 2.99969 23 4.00098 23 5.24977V9.74993C21.79 9.74993 20.8 10.7512 20.8 12C20.8 13.2427 21.785 14.2501 23 14.2501V18.7502C23 19.9929 22.015 21.0003 20.8 21.0003H3.2C1.98497 21.0003 1 19.9929 1 18.7502V14.2501C2.21503 14.2501 3.2 13.2427 3.2 12C3.2 10.7625 2.221 9.74993 1 9.74993V5.24977ZM11.79 14.7003L15.37 17.0004L14.28 12.8902L17.57 10.2001L13.33 9.95014L11.79 6L10.24 9.94014L6 10.1901L9.29 12.8802L8.21 17.0004L11.79 14.7003Z'
        fill={fill || themeColor.palesky}
      />
      <mask
        id='PromotionsEJ_svg__a'
        maskUnits='userSpaceOnUse'
        x={1}
        y={1}
        width={22}
        height={22}
      ></mask>
      <g mask='url(#PromotionsEJ_svg__a)'>
        <path fill={fill || themeColor.palesky} d='M0 0h24v23.999H0z' />
      </g>
    </svg>
  );
};

export const SvgPromotionsActive = (props): JSX.Element => {
  const { fill, ...rest } = props;
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.4082 5.85779L17.7857 2.1018L13.8265 2.69536L11 0L8.16326 2.73428L4.21429 2.11153L3.59184 5.83833L0.0102041 7.59956L1.81633 10.9761L0 14.3818L3.56122 16.1138L4.19388 19.899L8.13265 19.2762L10.9694 22.0008L13.7959 19.3151L17.7653 19.9087L18.3878 16.1527L22 14.4109L20.1837 11.0052L21.9898 7.59956L18.4082 5.85779ZM7.33672 15.8705L16.102 7.51196L14.6633 6.13995L5.89795 14.4985L7.33672 15.8705ZM6.91833 7.59954C6.91833 6.79343 7.60361 6.13995 8.44895 6.13995C9.29428 6.13995 9.97956 6.79343 9.97956 7.59954C9.97956 8.40564 9.29428 9.05912 8.44895 9.05912C7.60361 9.05912 6.91833 8.40564 6.91833 7.59954ZM12.0204 14.411C12.0204 13.6049 12.7057 12.9514 13.551 12.9514C14.3963 12.9514 15.0816 13.6049 15.0816 14.411C15.0816 15.2171 14.3963 15.8706 13.551 15.8706C12.7057 15.8706 12.0204 15.2171 12.0204 14.411Z'
        fill={fill || '#54AF48'}
      />
    </svg>
  );
};

export function SvgRewardAsTender(props) {
  const { fill, ...rest } = props;
  return (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.5 3.99878H5.5V15.9992H13.5189C13.5064 15.8345 13.5 15.6681 13.5 15.5002C13.5 14.9835 13.5603 14.481 13.6742 13.9991H9.5C9.5 13.4687 9.28929 12.96 8.91421 12.5849C8.53914 12.2098 8.03043 11.9991 7.5 11.9991V7.99892C8.03043 7.99892 8.53914 7.7882 8.91421 7.41311C9.28929 7.03803 9.5 6.5293 9.5 5.99885H19.5C19.5 6.5293 19.7107 7.03803 20.0858 7.41311C20.4609 7.7882 20.9696 7.99892 21.5 7.99892V9.17389C22.2204 9.34406 22.8945 9.6341 23.5 10.0218V3.99878ZM13.9977 17.9993C14.3094 18.7469 14.7566 19.4238 15.3086 19.9993H1.5V7.99892H3.5V17.9993H13.9977ZM17.4607 9.51469C17.3599 8.89855 17.0685 8.32476 16.6213 7.87759C16.0587 7.31497 15.2956 6.99888 14.5 6.99888C13.7044 6.99888 12.9413 7.31497 12.3787 7.87759C11.8161 8.44022 11.5 9.20331 11.5 9.99899C11.5 10.7947 11.8161 11.5578 12.3787 12.1204C12.8257 12.5674 13.3993 12.8588 14.0152 12.9597C14.6728 11.4122 15.9131 10.1721 17.4607 9.51469Z'
        fill={fill || '#4AA73D'}
      />
      <path
        d='M20 10L17.4688 12.5313L20 15.0627V13.3751C21.5525 13.3751 22.8125 14.6352 22.8125 16.1877C22.8125 16.6377 22.7112 17.0652 22.52 17.4478L23.7463 18.6741C24.2188 17.9653 24.5 17.1102 24.5 16.1877C24.5 13.7014 22.4862 11.6876 20 11.6876V10ZM16.2538 13.7014C15.7813 14.4102 15.5 15.2652 15.5 16.1877C15.5 18.6741 17.5138 20.6879 20 20.6879V22.3754L22.5312 19.8441L20 17.3128V19.0003C18.4475 19.0003 17.1875 17.7403 17.1875 16.1877C17.1875 15.7377 17.2888 15.3102 17.48 14.9277L16.2538 13.7014Z'
        fill={fill || '#4AA73D'}
      />
      <mask
        id='RewardAsTender_svg__a'
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={25}
        height={22}
      ></mask>
      <g mask='url(#RewardAsTender_svg__a)'>
        <path fill={fill || themeColor.palesky} d='M0-1h24v24H0z' />
      </g>
    </svg>
  );
}

// TBR Checkmark Empty
export function SvgTBRCheckboxEmpty(props) {
  const { fill, ...rest } = props;

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <circle cx='12' cy='12' r='11.75' fill={fill || 'white'} stroke='#E5E5E5' strokeWidth='0.5' />
    </svg>
  );
}

// TBR Checkmark Full
export function SvgTBRCheckboxFilled(props) {
  const { fill, ...rest } = props;
  return (
    <svg width='24' height='24' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.08301 12.9999C1.08301 6.42192 6.42167 1.08325 12.9997 1.08325C19.5777 1.08325 24.9163 6.42192 24.9163 12.9999C24.9163 19.5779 19.5777 24.9166 12.9997 24.9166C6.42167 24.9166 1.08301 19.5779 1.08301 12.9999ZM5.49211 13.8341L9.77019 18.1122C10.2349 18.577 10.9976 18.577 11.4504 18.1122L20.4952 9.06747C20.9599 8.60272 20.9599 7.85197 20.4952 7.38722C20.0304 6.92247 19.2797 6.92247 18.8149 7.38722L10.6163 15.5859L7.17236 12.1539C6.70761 11.6891 5.95686 11.6891 5.49211 12.1539C5.26897 12.3765 5.14356 12.6788 5.14356 12.994C5.14356 13.3092 5.26897 13.6115 5.49211 13.8341Z'
        fill={fill || themeColor.palesky}
        {...rest}
      />
      <mask
        id='mask0'
        mask-type='alpha'
        maskUnits='userSpaceOnUse'
        x='1'
        y='1'
        width='26'
        height='26'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.08301 12.9999C1.08301 6.42192 6.42167 1.08325 12.9997 1.08325C19.5777 1.08325 24.9163 6.42192 24.9163 12.9999C24.9163 19.5779 19.5777 24.9166 12.9997 24.9166C6.42167 24.9166 1.08301 19.5779 1.08301 12.9999ZM5.49211 13.8341L9.77019 18.1122C10.2349 18.577 10.9976 18.577 11.4504 18.1122L20.4952 9.06747C20.9599 8.60272 20.9599 7.85197 20.4952 7.38722C20.0304 6.92247 19.2797 6.92247 18.8149 7.38722L10.6163 15.5859L7.17236 12.1539C6.70761 11.6891 5.95686 11.6891 5.49211 12.1539C5.26897 12.3765 5.14356 12.6788 5.14356 12.994C5.14356 13.3092 5.26897 13.6115 5.49211 13.8341Z'
          fill={fill || themeColor.palesky}
        />
      </mask>
      <g mask='url(#mask0)'>
        <rect width='26' height='26' fill={fill || '#54AF48'} />
      </g>
    </svg>
  );
}

// TBR Checkmark Half
export function SvgTBRCheckboxHalf(props) {
  const { fill, ...rest } = props;
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <circle cx='12' cy='12' r='11.75' fill={fill || 'white'} stroke='#E5E5E5' strokeWidth='0.5' />
      <path
        d='M11.75 12V12.0388V12.0776V12.1164V12.1551V12.1938V12.2325V12.2711V12.3097V12.3483V12.3869V12.4254V12.4639V12.5023V12.5408V12.5792V12.6175V12.6559V12.6942V12.7324V12.7707V12.8089V12.847V12.8852V12.9233V12.9614V12.9994V13.0374V13.0754V13.1133V13.1512V13.1891V13.2269V13.2647V13.3025V13.3402V13.3779V13.4156V13.4532V13.4908V13.5284V13.5659V13.6034V13.6408V13.6782V13.7156V13.7529V13.7902V13.8275V13.8647V13.9019V13.939V13.9761V14.0132V14.0503V14.0872V14.1242V14.1611V14.198V14.2348V14.2716V14.3084V14.3451V14.3818V14.4184V14.455V14.4916V14.5281V14.5646V14.601V14.6374V14.6737V14.71V14.7463V14.7825V14.8187V14.8549V14.891V14.927V14.963V14.999V15.0349V15.0708V15.1066V15.1424V15.1782V15.2139V15.2495V15.2851V15.3207V15.3562V15.3917V15.4272V15.4625V15.4979V15.5332V15.5684V15.6036V15.6388V15.6739V15.709V15.744V15.779V15.8139V15.8487V15.8836V15.9184V15.9531V15.9878V16.0224V16.057V16.0915V16.126V16.1604V16.1948V16.2292V16.2635V16.2977V16.3319V16.366V16.4001V16.4341V16.4681V16.5021V16.5359V16.5698V16.6035V16.6373V16.6709V16.7046V16.7381V16.7717V16.8051V16.8385V16.8719V16.9052V16.9384V16.9716V17.0048V17.0379V17.0709V17.1039V17.1368V17.1697V17.2025V17.2353V17.268V17.3006V17.3332V17.3657V17.3982V17.4307V17.463V17.4953V17.5276V17.5598V17.5919V17.624V17.656V17.688V17.7199V17.7518V17.7836V17.8153V17.847V17.8786V17.9101V17.9416V17.9731V18.0045V18.0358V18.067V18.0982V18.1294V18.1605V18.1915V18.2224V18.2533V18.2842V18.3149V18.3457V18.3763V18.4069V18.4374V18.4679V18.4983V18.5286V18.5589V18.5891V18.6193V18.6493V18.6794V18.7093V18.7392V18.769V18.7988V18.8285V18.8581V18.8877V18.9172V18.9466V18.976V19.0053V19.0346V19.0638V19.0929V19.1219V19.1509V19.1798V19.2086V19.2374V19.2661V19.2948V19.3233V19.3518V19.3803V19.4086V19.4369V19.4652V19.4933V19.5214V19.5495V19.5774V19.6053V19.6331V19.6609V19.6885V19.7161V19.7437V19.7711V19.7985V19.8259V19.8531V19.8803V19.9074V19.9344V19.9614V19.9883V20.0151V20.0419V20.0685V20.0951V20.1217V20.1481V20.1745V20.2008V20.227V20.2532V20.2793V20.3053V20.3312V20.3571V20.3829V20.4086V20.4342V20.4598V20.4853V20.5107V20.536V20.5613V20.5865V20.6116V20.6366V20.6615V20.6864V20.7112V20.7359V20.7606V20.7851V20.8096V20.834V20.8584V20.8826V20.9068V20.9309V20.9549V20.9788V21.0027V21.0265V21.0502V21.0738V21.0973V21.1208V21.1441V21.1674V21.1906V21.2138V21.2368V21.2598V21.2827V21.3055V21.3282V21.3508V21.3734V21.3959V21.4183V21.4406V21.4628V21.4849V21.507V21.529V21.5509V21.5727V21.5944V21.616V21.6376V21.659V21.6804V21.7017V21.7229V21.7441V21.7651V21.7861V21.8069V21.8277V21.8484V21.869V21.8895V21.91V21.9303V21.9506V21.9708V21.9908V22.0108V22.0308V22.0506V22.0703V22.09V22.1095V22.129V22.1483V22.1676V22.1868V22.2059V22.225V22.2439V22.2627V22.2815V22.3001V22.3187V22.3372V22.3555V22.3738V22.392V22.4101V22.4282V22.4461V22.4639V22.4816V22.4993V22.5168V22.5343V22.5517V22.5689V22.5861V22.6032V22.6202V22.6371V22.6539V22.6706V22.6872V22.7037V22.7201V22.7365V22.7527V22.7688V22.7849V22.8008V22.8167V22.8324V22.8481V22.8636V22.8791V22.8945V22.9097V22.9249V22.94V22.9549V22.9698V22.9846V22.9993V23.0138V23.0283V23.0427V23.057V23.0712V23.0852V23.0992V23.1131V23.1269V23.1406V23.1542V23.1676V23.181V23.1943V23.2075V23.2206V23.2335V23.2464V23.2592V23.2718V23.2844V23.2969V23.3092V23.3215V23.3337V23.3457V23.3577V23.3695V23.3812V23.3929V23.4044V23.4158V23.4272V23.4384V23.4495V23.4605V23.4714V23.4822V23.4929V23.5035V23.514V23.5243V23.5346V23.5448V23.5548V23.5648V23.5746V23.5844V23.594V23.6035V23.6129V23.6222V23.6314V23.6405V23.6495V23.6583V23.6671V23.6757V23.6843V23.6927V23.701V23.7092V23.7174V23.7253V23.7332V23.741V23.7474C5.37608 23.6144 0.25 18.4058 0.25 12C0.25 5.59419 5.37608 0.385648 11.75 0.252607V0.259005V0.266776V0.274657V0.282648V0.29075V0.298962V0.307284V0.315715V0.324256V0.332906V0.341666V0.350534V0.359512V0.368597V0.377792V0.387094V0.396505V0.406023V0.41565V0.425383V0.435224V0.445172V0.455227V0.465389V0.475658V0.486032V0.496514V0.507101V0.517794V0.528592V0.539496V0.550506V0.56162V0.57284V0.584164V0.595592V0.607126V0.618763V0.630504V0.642349V0.654298V0.66635V0.678506V0.690764V0.703126V0.71559V0.728157V0.740826V0.753597V0.76647V0.779445V0.792522V0.8057V0.81898V0.83236V0.845841V0.859423V0.873106V0.886889V0.900772V0.914755V0.928837V0.943019V0.957301V0.971682V0.986162V1.00074V1.01542V1.03019V1.04507V1.06004V1.07511V1.09028V1.10555V1.12091V1.13637V1.15193V1.16758V1.18333V1.19918V1.21512V1.23116V1.2473V1.26353V1.27985V1.29628V1.31279V1.32941V1.34611V1.36291V1.37981V1.3968V1.41388V1.43106V1.44834V1.4657V1.48316V1.50071V1.51836V1.53609V1.55392V1.57185V1.58986V1.60797V1.62617V1.64446V1.66284V1.68131V1.69988V1.71853V1.73728V1.75612V1.77504V1.79406V1.81317V1.83237V1.85165V1.87103V1.89049V1.91005V1.92969V1.94943V1.96925V1.98916V2.00915V2.02924V2.04941V2.06967V2.09002V2.11046V2.13098V2.15159V2.17228V2.19307V2.21394V2.23489V2.25593V2.27706V2.29827V2.31957V2.34095V2.36242V2.38398V2.40561V2.42734V2.44914V2.47103V2.49301V2.51507V2.53721V2.55943V2.58174V2.60413V2.62661V2.64917V2.6718V2.69453V2.71733V2.74022V2.76318V2.78623V2.80936V2.83258V2.85587V2.87924V2.9027V2.92623V2.94985V2.97354V2.99732V3.02117V3.0451V3.06912V3.09321V3.11738V3.14163V3.16596V3.19037V3.21485V3.23942V3.26406V3.28878V3.31358V3.33845V3.3634V3.38843V3.41353V3.43872V3.46397V3.48931V3.51472V3.5402V3.56577V3.5914V3.61712V3.6429V3.66877V3.6947V3.72071V3.7468V3.77296V3.7992V3.8255V3.85189V3.87834V3.90487V3.93147V3.95815V3.98489V4.01171V4.0386V4.06557V4.09261V4.11971V4.14689V4.17414V4.20147V4.22886V4.25632V4.28386V4.31146V4.33914V4.36689V4.3947V4.42259V4.45054V4.47857V4.50666V4.53482V4.56306V4.59136V4.61972V4.64816V4.67667V4.70524V4.73388V4.76259V4.79137V4.82021V4.84912V4.8781V4.90714V4.93625V4.96543V4.99467V5.02398V5.05335V5.08279V5.11229V5.14186V5.1715V5.2012V5.23096V5.26079V5.29069V5.32064V5.35066V5.38075V5.4109V5.44111V5.47138V5.50172V5.53212V5.56258V5.59311V5.6237V5.65435V5.68506V5.71583V5.74667V5.77756V5.80852V5.83954V5.87062V5.90176V5.93296V5.96422V5.99554V6.02692V6.05836V6.08986V6.12141V6.15303V6.18471V6.21644V6.24824V6.28009V6.312V6.34397V6.37599V6.40807V6.44022V6.47241V6.50467V6.53698V6.56935V6.60178V6.63426V6.66679V6.69939V6.73204V6.76474V6.7975V6.83032V6.86319V6.89612V6.9291V6.96213V6.99522V7.02836V7.06156V7.09481V7.12812V7.16147V7.19489V7.22835V7.26187V7.29544V7.32906V7.36273V7.39646V7.43024V7.46407V7.49795V7.53188V7.56587V7.5999V7.63399V7.66812V7.70231V7.73655V7.77084V7.80517V7.83956V7.874V7.90848V7.94302V7.9776V8.01224V8.04692V8.08165V8.11642V8.15125V8.18612V8.22105V8.25602V8.29103V8.3261V8.36121V8.39636V8.43157V8.46682V8.50211V8.53746V8.57284V8.60828V8.64376V8.67928V8.71485V8.75047V8.78613V8.82183V8.85758V8.89337V8.92921V8.96509V9.00101V9.03698V9.07299V9.10905V9.14514V9.18128V9.21746V9.25369V9.28995V9.32626V9.36261V9.399V9.43544V9.47191V9.50843V9.54498V9.58158V9.61822V9.6549V9.69162V9.72837V9.76517V9.80201V9.83889V9.8758V9.91276V9.94975V9.98678V10.0239V10.061V10.0981V10.1353V10.1725V10.2098V10.2471V10.2844V10.3218V10.3592V10.3966V10.4341V10.4716V10.5092V10.5468V10.5844V10.6221V10.6598V10.6975V10.7353V10.7731V10.8109V10.8488V10.8867V10.9246V10.9626V11.0006V11.0386V11.0767V11.1148V11.153V11.1911V11.2293V11.2676V11.3058V11.3441V11.3825V11.4208V11.4592V11.4977V11.5361V11.5746V11.6131V11.6517V11.6903V11.7289V11.7675V11.8062V11.8449V11.8836V11.9224V11.9612V12Z'
        fill={fill || '#54AF48'}
        stroke='#54AF48'
        strokeWidth='0.5'
      />
    </svg>
  );
}
